export default __webpack_public_path__ + "static/media/2.78e8fdb8.jpg";